import { render, staticRenderFns } from "./WeeklyWorkDangjinReply.vue?vue&type=template&id=88bfbdc2"
import script from "./WeeklyWorkDangjinReply.vue?vue&type=script&lang=js"
export * from "./WeeklyWorkDangjinReply.vue?vue&type=script&lang=js"
import style0 from "./WeeklyWorkDangjinReply.vue?vue&type=style&index=0&id=88bfbdc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports